export const getResolver = (validatorFunc) => {
  return async (data) => {
    const valid = validatorFunc(data);
    let errors = {};
    if (!valid && validatorFunc.errors) {
      validatorFunc.errors.forEach((error) => {
        const { instancePath, message } = error;
        const fieldName = instancePath.substring(instancePath.lastIndexOf('/') + 1);
        errors[fieldName] = message;
      });
    } else {
      errors = {};
    }

    return {
      values: valid ? data : {},
      errors,
    };
  };
};
